import React from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { Box, Button, RadioButton } from '@sparknz/spark-pattern-library';
import { trackCustomLink } from '@sparknz/tracking';

import { FormData } from 'journey/checkout/types';
import { StoreItemViewModel } from 'shared/types/store';
import { StoreStockBox, Subtitle } from './components';
import { Selection, StoreRow } from './StoreList.style';

interface StoreListWithRadioProps {
  stores: StoreItemViewModel[];
  field: ControllerRenderProps<FormData, string>;
  setInfoLayerOpen: (open: boolean) => void;
  setSelectedStore: (store: StoreItemViewModel) => void;
}
function StoreListWithRadio({
  field,
  stores,
  setSelectedStore,
  setInfoLayerOpen,
}: StoreListWithRadioProps) {
  const toggleMoreDetails = (storeId: string) => {
    const store = stores?.find((s) => s.id === storeId);
    trackCustomLink(`${store.storeName} More details`);
    setSelectedStore(store);
    setInfoLayerOpen(true);
  };

  const handleStoreSelection = (storeId: string) => {
    const store = stores?.find((s) => s.id === storeId);
    setSelectedStore(store);
  };

  return (
    <>
      {stores.map((store) => (
        <StoreRow key={store.id}>
          <Selection>
            <RadioButton
              checked={field.value === store.id}
              onChange={() => handleStoreSelection(store.id)}
              value={store.displayName}
              disabled={store.stockStatus !== 'IN_STOCK'}
              text={store.displayName}
            />
            <Box pl="s5">
              <Subtitle store={store} />
              <Button
                variant="textbutton"
                onClick={() => toggleMoreDetails(store.id)}
                mb=""
                type="button"
                data-testId={`toggle-${store.id}`}
              >
                See store hours
              </Button>
            </Box>
          </Selection>
          <StoreStockBox store={store} />
        </StoreRow>
      ))}
    </>
  );
}

export default StoreListWithRadio;
